/**
 * Simple Horizontal Pill Tab Component
 */
(function() {
    'use strict';
    
    function HPillTabComponent(element) {
        this.element = element;
        this.currentTabIndex = 0;
        this.init();
    }
    
    HPillTabComponent.prototype.init = function() {
        this.cacheElements();
        this.setInitialState();
        this.bindEvents();
        this.updateIndicator();
        
        console.log('H-Pill Tab component initialized');
    };
    
    HPillTabComponent.prototype.cacheElements = function() {
        this.tabTriggers = this.element.querySelectorAll('.h-pill-tab-trigger');
        this.tabPanels = this.element.querySelectorAll('.h-pill-tab-panel');
        this.tabIndicator = this.element.querySelector('.h-pill-tab-indicator');
        
        if (!this.tabTriggers.length || !this.tabPanels.length) {
            throw new Error('Tab triggers or panels not found');
        }
    };
    
    HPillTabComponent.prototype.setInitialState = function() {
        // Find active tab or set first as active
        var activeIndex = 0;
        for (var i = 0; i < this.tabTriggers.length; i++) {
            if (this.tabTriggers[i].classList.contains('active')) {
                activeIndex = i;
                break;
            }
        }
        this.currentTabIndex = activeIndex;
        this.activateTab(activeIndex);
    };
    
    HPillTabComponent.prototype.activateTab = function(index) {
        // Remove active class from all
        for (var i = 0; i < this.tabTriggers.length; i++) {
            this.tabTriggers[i].classList.remove('active');
        }
        for (var j = 0; j < this.tabPanels.length; j++) {
            this.tabPanels[j].classList.remove('active');
        }
        
        // Add active class to current
        if (this.tabTriggers[index]) {
            this.tabTriggers[index].classList.add('active');
        }
        if (this.tabPanels[index]) {
            this.tabPanels[index].classList.add('active');
        }
        
        this.currentTabIndex = index;
        this.updateIndicator();
    };
    
    HPillTabComponent.prototype.updateIndicator = function() {
        if (!this.tabIndicator || !this.tabTriggers[this.currentTabIndex]) return;
        
        var activeTab = this.tabTriggers[this.currentTabIndex];
        var nav = this.element.querySelector('.h-pill-tab-nav');
        
        if (!nav) return;
        
        var tabRect = activeTab.getBoundingClientRect();
        var navRect = nav.getBoundingClientRect();
        
        var leftOffset = tabRect.left - navRect.left;
        var width = tabRect.width;
        
        this.tabIndicator.style.width = width + 'px';
        this.tabIndicator.style.transform = 'translateX(' + leftOffset + 'px)';
    };
    
    HPillTabComponent.prototype.bindEvents = function() {
        var self = this;
        
        // Tab click events
        for (var i = 0; i < this.tabTriggers.length; i++) {
            (function(index) {
                self.tabTriggers[index].addEventListener('click', function(e) {
                    e.preventDefault();
                    self.activateTab(index);
                });
                
                // Keyboard navigation
                self.tabTriggers[index].addEventListener('keydown', function(e) {
                    var newIndex;
                    
                    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                        e.preventDefault();
                        newIndex = index > 0 ? index - 1 : self.tabTriggers.length - 1;
                    } else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                        e.preventDefault();
                        newIndex = index < self.tabTriggers.length - 1 ? index + 1 : 0;
                    }
                    
                    if (typeof newIndex !== 'undefined') {
                        self.activateTab(newIndex);
                        self.tabTriggers[newIndex].focus();
                    }
                });
            })(i);
        }
        
        // Update indicator on window resize
        window.addEventListener('resize', function() {
            setTimeout(function() {
                self.updateIndicator();
            }, 100);
        });
    };
    
    // Initialize when DOM is ready
    document.addEventListener('DOMContentLoaded', function() {
        var elements = document.querySelectorAll('[data-h-pill-tab-component]');
        
        for (var i = 0; i < elements.length; i++) {
            try {
                new HPillTabComponent(elements[i]);
            } catch (error) {
                console.error('Failed to initialize h-pill tab component:', error);
            }
        }
    });
    
})();